import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { FlightRoutePaths, FlightsRoutePathName } from '@/modules/to/flight/flight.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: 'entity/flights',
      name: FlightsRoutePathName,
      component: () =>
        import(/* webpackChunkName: "flight-list-page" */ './pages/FlightListPage.vue'),
    },
    {
      path: `entity/flights/:id`,
      name: FlightRoutePaths.EDIT_FLIGHT_ROUTE_PATH_NAME,
      component: () =>
        import(/* webpackChunkName: "flight-details-page" */ './pages/FlightDetailsPage.vue'),
      props: true,
    },
  ],
  Module.FLIGHT
);
